import controller from './developers.controller';
import template from './developers.html';

let component = {
    template,
    controller
};

export default component;
